<template>
  <!-- Mobile Nav -->
  <button class="block md:hidden">
    <ion-icon
      name="wallet-sharp"
      class="text-primary border border-1 border-primary p-2 transition duration-300 hover:bg-primary hover:text-white"
      @click="connectWallet"
      v-if="!this.$store.state.account && !this.$store.web3"
    ></ion-icon>
    <ion-icon
      name="power-sharp"
      class="text-primary border border-1 border-primary p-2 transition duration-300 hover:bg-primary hover:text-white"
      v-else
    ></ion-icon>
  </button>

  <!-- Desktop Nav -->
  <button
    class="hidden md:block hover:bg-primary transition duration-300 rounded-md"
    @click="connectWallet"
    v-if="!this.$store.state.account && !this.$store.web3"
  >
    <div class="flex">
      <MdPersonIcon
        w="24"
        h="24"
        class="outline outline-1 outline-primary rounded-l-md p-2 fill-foreground"
      /><span
        class="outline outline-1 py-2 px-4 outline-primary rounded-r-md text-foreground"
      >
        Connect</span
      >
    </div>
  </button>
  <button v-else class="hidden md:block rounded-md">
    <div class="flex">
      <ion-icon
        name="power"
        class="transition duration-300 outline outline-1 outline-primary rounded-l-md p-2 text-2xl hover:bg-primary fill-foreground"
        @click="disconnectWallet"
      ></ion-icon>
      <span
        class="outline outline-1 py-2 px-4 outline-primary rounded-r-md text-foreground"
      >
        {{ getCondensedAddress() }}</span
      >
    </div>
  </button>
</template>

<script>
import MdPersonIcon from "vue-ionicons/dist/md-person.vue";
export default {
  components: { MdPersonIcon },
  methods: {
    async connectWallet() {
      await this.$store.dispatch("ConnectWallet");
    },
    disconnectWallet() {
      this.$store.dispatch("DisconnectWallet");
    },
    getCondensedAddress() {
      let addr = this.$store.state.account;
      addr = addr.slice(0, 6) + "..." + addr.slice(-4);

      return addr;
    },
  },
};
</script>
